import React, {useEffect, useRef} from 'react';
import {bool, func, shape, string} from 'prop-types';
import {compose} from 'redux';
import {connect} from 'react-redux';
import { injectIntl, intlShape} from '../../util/reactIntl';
import {addIndex, map, path, pathOr} from 'ramda';

import {propTypes} from '../../util/types';
import {types as sdkTypes} from '../../util/sdkLoader';
import {ensureListing, ensureUser} from '../../util/data';
import {isScrollingDisabled} from '../../ducks/UI.duck';
import {getMarketplaceEntities} from '../../ducks/marketplaceData.duck';
import {
  Divider,
  DummyTopbar,
  HeadingWithBackButton,
  Page,
} from '../../components';

import EnquiryPanel from './EnquiryPanel/EnquiryPanel';
import InformationPanel from './InformationPanel/InformationPanel';
import css from './ContactPage.module.css';
import {isMessage} from '../../components/ActivityFeed/ActivityFeed.helpers';
import OwnMessage from '../../components/ActivityFeed/components/Message/OwnMessage';
import Message from '../../components/ActivityFeed/components/Message/Message';
import classNames from 'classnames';
import {MAX_MOBILE_WIDTH} from '../../util/constants';
import {withViewport} from '../../util/contextHelpers';
import SendMessageForm from './SendMessageForm/SendMessageForm';
import {verifyDiscountCode} from '../CheckoutPage/CheckoutPage.duck';
import {
  resetListingChatBotMessages,
  sendNewListingChatBotMessage,
} from './ListingChatBotPage.duck';
import {isNilOrEmpty} from '../../util/validators';
import {useHistory, useLocation} from 'react-router-dom';
import {parse, stringify} from "../../util/urlHelpers";

const {UUID} = sdkTypes;
const MOBILE_MAX_WIDTH = 900;

const ContactPage = (props) => {
  const {
    fetchReviewsError,
    getListing,
    intl,
    params,
    reviews,
    scrollingDisabled,
    showListingError,
    messages = [],
    viewport,
    currentUser,
    isLoading,
    sendNewListingChatBotMessage,
    resetListingChatBotMessages,
    error,
  } = props;
  const messagesEndRef = useRef(null);
  const location = useLocation();
  const history = useHistory();
  const listingId = new UUID(params.id);
  const currentListing = ensureListing(getListing(listingId));
  // const isLoading = !currentListing.id;
  const currentAuthor = ensureUser(currentListing.author);
  const currentAuthorDisplayName = path(['attributes', 'profile', 'displayName'], currentAuthor);
  const canShowPage = !showListingError;
  const loadingTitleText = intl.formatMessage({id: 'Marketplace.loading'});
  const isMobile = viewport.width <= MOBILE_MAX_WIDTH;
  const headingText = intl.formatMessage({id: `ListingChatBotPage.${!isMobile ? 'heading' : 'headingMobile'}`}, {title: currentListing?.attributes.title});
  const pageProps = {title: isLoading ? loadingTitleText : headingText, scrollingDisabled};
  const loadingErrorText = intl.formatMessage({id: 'ContactPage.loadingError'});
  const {width} = viewport;
  const hasViewport = width > 0;
  const isMobileDevice = hasViewport && width <= MAX_MOBILE_WIDTH;
  useEffect(() => {
    if (!messages.length) return;

    messagesEndRef.current.scrollIntoView();
  }, [messages?.length]);
  useEffect(() => {
    if (!listingId) return;

    resetListingChatBotMessages(listingId.uuid);
  }, [listingId?.uuid]);
  const handleSend = ({message}) => {
    const listingData = path(['attributes'], currentListing);
    console.log('handleSend', message, listingData);
    if (isNilOrEmpty(message) || isNilOrEmpty(listingData)) return;

    sendNewListingChatBotMessage(message?.trim(), currentUser, listingData, listingId?.uuid);
  };
  const messageComponent = (message, prevMessageHasSameAuthor, nextMessageHasSameAuthor) => {
    const messageProps = {
      message,
      intl,
      isMobileDevice,
      nextMessageHasSameAuthor,
      prevMessageHasSameAuthor,
    };
    const isProposalPattern = (input) => {
      const pattern = /__proposal:({.*}):proposal__/;
      return pattern.test(input);
    };

    const text = message?.attributes?.content;
    const isOwnMessage =
      message.sender &&
      message.sender.id &&
      currentUser &&
      currentUser.id &&
      message.sender.id.uuid === currentUser.id.uuid;
    if (isOwnMessage) {
      return <OwnMessage {...messageProps} isFilled/>;
    }
    return <Message {...messageProps} />;
  };
  const handleGoBackAndShowMakeOfferButton = (e) => {
    e.preventDefault();
    const {handleBookingParamsChange} = location;
    if (!handleBookingParamsChange) {
      const {search } = location;
      const searchParams = parse(search);
      const newSearchParams = {
        ...searchParams,
        adults: 10,
      };
      const searchString = `?${stringify(newSearchParams)}`;
      history.push({
        pathname: 'l',
        search: searchString,
      });
      return;
    }

    handleBookingParamsChange({
      adults: 10,
    });
  };
  const messageListItem = (message, index, array) => {
    const arrayLength = array.length;
    const hasPrevItem = index > 0;
    const hasNextItem = arrayLength - 1 > index;
    const prevItem = hasPrevItem && array[index - 1];
    const nextItem = hasNextItem && array[index + 1];
    const prevItemIsMessage = prevItem && isMessage(prevItem);
    const nextItemIsMessage = nextItem && isMessage(nextItem);
    const prevMessageHasSameAuthor =
      false;
    // prevItemIsMessage && message.sender?.id.uuid === prevItem.sender?.id.uuid;
    const nextMessageHasSameAuthor =
      false;
    // nextItemIsMessage && message.sender?.id.uuid === nextItem.sender?.id.uuid;
    const messageItemClasses = classNames(css.messageItem, {
      [css.messageItemSameAuthor]: nextMessageHasSameAuthor,
    });

    if (message.isEvent) return (
      <div className={css.bypassingErrorPadding}>
        <div className={css.bypassingErrorContainer}>
          <div className={css.bypassTitle}>
            {intl.formatMessage({id: 'InboxPage.LookForEventTitle'})}
          </div>
          <div className={css.bypassDescription}>
            {intl.formatMessage({id: 'InboxPage.LookForEventDescription'})}
          </div>

          <div
            className={css.bookLink}
            onClick={handleGoBackAndShowMakeOfferButton}
          >
            {intl.formatMessage({id: 'InboxPage.LookForEventCTA'})}
          </div>
        </div>
      </div>
    )
    if (message.isPriceAndCalendarQuestion) return (
      <EnquiryPanel
        key={message.id}
        className={css.enquiryPanel}
        intl={intl}
        listing={currentListing}
        slug={params.slug}
      />
    );

    return (
      <li id={`msg-${message.id}`} key={message.id} className={messageItemClasses}>
        {messageComponent(message, prevMessageHasSameAuthor, nextMessageHasSameAuthor)}
      </li>
    );
  };
  // if (isLoading) {
  //   return (
  //     <Page {...pageProps}>
  //       <DummyTopbar/>
  //       <IconSpinner className={css.iconSpinner}/>
  //     </Page>
  //   );
  // }

  return (
    <Page className={css.root} {...pageProps}>
      <DummyTopbar className={css.dummyTopbar}/>
      <div className={css.mainContent}>
        <HeadingWithBackButton className={css.headingWithBackButton} heading={headingText}/>
        {canShowPage ? (
          <div className={css.panelContainer}>
            <InformationPanel
              className={css.informationPanel}
              intl={intl}
              listing={currentListing}
              slug={params.slug}
            />
            <div className={css.mainPanelContainer}>
              <Divider className={css.divider}/>
              <div className={css.chat}>
                {messages.map((message, index, array) => messageListItem(message, index, array))}
                <div className={css.chatEnd} ref={messagesEndRef} />
              </div>
              <SendMessageForm
                formId="ListingChatBotPage.SendMessageForm"
                rootClassName={css.sendMessageForm}
                messagePlaceholder={intl.formatMessage({id: 'ListingChatBotPage.askYourQuestion'})}
                inProgress={isLoading}
                isMobile={isMobileDevice}
                sendMessageError={error}
                // onFocus={onSendMessageFormFocus}
                // onBlur={onSendMessageFormBlur}
                onSubmit={handleSend}
              />
            </div>
          </div>
        ) : (
          <span className={css.error}>{loadingErrorText}</span>
        )}
      </div>
    </Page>
  );
};

ContactPage.defaultProps = {
  currentUser: null,
};

ContactPage.propTypes = {
  scrollingDisabled: bool.isRequired,
  currentUser: propTypes.currentUser,
  getListing: func.isRequired,
  params: shape({
    id: string,
    slug: string,
  }).isRequired,
  intl: intlShape.isRequired,
};

const eventDetected = (input) => {
  const pattern = /__eventAsked__/;
  return pattern.test(input);
};
const priceAndCalendarDetected = (input) => {
  const pattern = /__priceAndCalendarAsked__/;
  return pattern.test(input);
};
const mapIndexed = addIndex(map);

const mapDispatchToProps = ({
  sendNewListingChatBotMessage,
  resetListingChatBotMessages,
});

const mapStateToProps = (state) => {
  const {
    isLoading,
    conversation = [],
    error,
  } = state.ListingChatBotPage;

  const getListing = id => {
    const ref = {id, type: 'listing'};
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };
  const parseMessages = (messages) =>
    mapIndexed((message, index) => {
      const isEvent = eventDetected(message.attributes.content);
      const isPriceAndCalendarQuestion = priceAndCalendarDetected(message.attributes.content);
      return {
        ...message,
        isEvent,
        isPriceAndCalendarQuestion,
      };
    }, messages);
  const messages = parseMessages(conversation);

  return {
    messages,
    currentUser: pathOr({}, ['user', 'currentUser'], state),
    isLoading,
    conversation,
    error,
    getListing,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

export default compose(
  withViewport,
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ContactPage);
